import { isRouteErrorResponse } from "react-router-dom";
import { config } from "@/config/env";

/**
 * Put a crash on the console with enough around it to be searchable. Console is
 * the whole story for now — there is no error reporting service wired up — so
 * this is also the single seam to swap for one later.
 */
export function logRouteError(error: unknown, where: string) {
  // A thrown Response (a loader's 404/403) is a routing outcome, not a bug.
  // Still worth a line, but not the one that should alarm anyone reading logs.
  if (isRouteErrorResponse(error)) {
    console.warn(`[${where}] ${error.status} ${error.statusText}`, error.data, {
      path: window.location.pathname,
    });
    return;
  }
  console.error(`[${where}]`, error, { path: window.location.pathname });
}

/** The message to show the operator, and the detail to show only in dev. */
export function describeRouteError(error: unknown): {
  title: string;
  detail: string | null;
} {
  if (isRouteErrorResponse(error)) {
    return {
      title:
        error.status === 404
          ? "We couldn't find that page."
          : `The server refused that request (${error.status}).`,
      detail: config.isDev ? (error.statusText ?? null) : null,
    };
  }
  const message = error instanceof Error ? error.message : String(error);
  return {
    title: "Something went wrong on this page.",
    // The real message belongs on a developer's screen, not an operator's.
    detail: config.isDev ? message : null,
  };
}
